import React from 'react';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import MedicalReportDetailPolandForm from './MedicalReportDetailPolandForm';

interface Props {
	onSuccess: (values: FormValues) => void;
	defaultData?: any;
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	disableSubmit?: boolean;
	isMeddiCase: boolean;
}

const MedicalReportDetailPoland: React.FC<Props> = ({
	onSuccess,
	defaultData,
	disableSubmit,
	patientId,
	isMeddiCase,
}) => {
	return (
		<MedicalReportDetailPolandForm
			onSubmit={onSuccess}
			defaultData={defaultData}
			disableSubmit={disableSubmit}
			patientId={patientId}
			isMeddiCase={isMeddiCase}
		/>
	);
};

export default MedicalReportDetailPoland;
